<template>
  <div style="overflow-y: auto; overflow-x: hidden" class="offer-sales-container">
    <mf-search v-model="search" hide-details placeholder="Busque por campanhas" />

    <paginated-data-table
      :headers="headers"
      :search="search"
      :query="query"
      :loading="loading"
      :custom-items-per-page="10"
      :query-variables="queryVariables"
      :graphql-uri="$microservicesUrls['sales']"
      query-name="offerSchedules"
    >
      <template #item="{ item }">
        <tr class="cursor-pointer" @click="toggleCampaign(item)">
          <td>
            <v-simple-checkbox :value="selectedCampaignsIds.includes(item._id)" color="primary" :ripple="false" @input="toggleCampaign(item)" />
          </td>
          <td class="nowrap-row">
            {{ getStatusLabel(item.status).text }}
          </td>
          <td class="nowrap-row">
            <v-tooltip v-model="showTooltipTitle[item._id]" max-width="250" top content-class="truncated-tooltip">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <a class="link" :href="link(item)" target="_blank">{{ item.name | truncate({ length: 20 }) }}</a>
                </span>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
          </td>
          <td class="nowrap-row">
            <v-tooltip v-model="showTooltipDescription[item._id]" top max-width="250" content-class="truncated-tooltip">
              <template #activator="{ on }">
                <span v-on="on">
                  {{ putEllipsis(item.description, 18) }}
                </span>
              </template>
              <span>{{ item.description }}</span>
            </v-tooltip>
          </td>
          <td class="nowrap-row">{{ Boolean(item.industry) ? 'Sim' : 'Não' }}</td>
          <td class="nowrap-row">
            <v-tooltip v-if="item.units.length > 0" right>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" style="cursor: auto" v-on="on">
                  {{ getUnits(item) }}
                </span>
              </template>
              <span v-for="(unit, index) in item.units" :key="index" style="display: block">
                {{ unit.name }}
              </span>
            </v-tooltip>
            <span v-else> - </span>
          </td>
          <td>{{ item.products_count }}</td>
          <td>
            <v-tooltip top max-width="300px">
              <template #activator="{ on }">
                <span v-on="on">{{ getOfferTypes(item.types).length === 1 ? getOfferTypes(item.types)[0] : 'Múltiplas' }}</span>
              </template>
              <span>{{ getOfferTypesTooltip(item.types) }}</span>
            </v-tooltip>
          </td>
          <td v-if="showTooltip(item.status)">
            <v-tooltip top>
              <template #activator="{ on }">
                <span v-on="on">{{ getPeriod(item.start_date, item.end_date) }}</span>
              </template>
              <span>{{ getCampaignDuration(item) }}</span>
            </v-tooltip>
          </td>
          <td v-else>
            <span>
              {{ getPeriod(item.start_date, item.end_date) }}
            </span>
          </td>
        </tr>
      </template>
    </paginated-data-table>
  </div>
</template>

<script>
import { DateTime } from 'luxon'

import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import { getStatusLabel, getUnits, getPeriod, putEllipsis } from '@/config/helpers.js'
import { QUERY_LIST_SALES_CAMPAIGNS } from '@/modules/campanhas/gestao-ofertas-v2/graphql'
import { getProductFormatTypeLabel } from '@/modules/mobile/ofertas/helpers/productType.js'
export default {
  name: 'FormMariaCampaignTab1',

  components: {
    PaginatedDataTable,
  },

  props: {
    value: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    isMariaCampaignActivated: {
      type: Boolean,
      default: false,
    },
    singleCheckbox: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Array,
      default: () => ['ACTIVE', 'FINISHED'],
    },
    hideIndustry: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    search: '',
    campaignId: '',
    showTooltipTitle: {},
    DateTime: DateTime,
    showTooltipDescription: {},
    selectedCampaignsIds: [],
    renderKeyDialog: 0,
    isOfferDialogOpen: false,
  }),

  computed: {
    query() {
      return QUERY_LIST_SALES_CAMPAIGNS
    },
    queryVariables() {
      return {
        status: this.status.map((status) => status.toLowerCase()),
        franchise: this.franchisee,
        includeAuto: false,
        units: this.units ? this.units : [],
        industry: this.hideIndustry ? false : undefined,
      }
    },
    headers() {
      return [
        {
          text: '',
          value: '_id',
          width: '5%',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          width: '7%',
        },
        {
          text: 'Nome',
          value: 'name',
          width: '15%',
        },
        {
          text: 'Descrição',
          value: 'description',
          width: '15%',
        },
        {
          text: 'Mercatrade',
          value: 'industry',
          width: '12%',
        },
        {
          text: 'Lojas',
          value: 'units',
          width: '7%',
        },
        {
          text: 'Produtos',
          value: 'products_count',
          width: '9%',
        },
        {
          text: 'Formato',
          value: 'types',
          width: '10%',
        },
        {
          text: 'Validade',
          value: 'start_date',
          width: '20%',
        },
      ]
    },
    selectedCampaigns: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    selectedCampaigns: {
      deep: true,

      handler(value) {
        this.selectedCampaignsIds = value.map(({ _id }) => _id)
      },
    },
  },
  mounted() {
    if (this.selectedCampaigns) this.selectedCampaignsIds = this.selectedCampaigns.map(({ _id }) => _id)
  },
  methods: {
    putEllipsis,
    getStatusLabel,
    getPeriod,
    getUnits,

    resetModalCounter() {
      this.$emit('reset-modal-counter')
    },

    showTooltip(status) {
      return status === 'active' || status === 'scheduled'
    },

    getCampaignDuration(item) {
      if (item.status === 'active') {
        const { days: endCampaign } = DateTime.fromISO(item.end_date).diffNow(['days']).toObject()
        return `A campanha terminará em ${parseInt(endCampaign)} dia(s)`
      } else if (item.status === 'scheduled') {
        const { days: initCampaign } = DateTime.fromISO(item.start_date).diffNow(['days']).toObject()
        return `A campanha iniciará em ${parseInt(initCampaign)} dia(s)`
      }
    },

    toggleOfferDialog(campaignId) {
      this.campaignId = campaignId
      this.isOfferDialogOpen = true
    },

    toggleCampaign(toggledCampaign) {
      if (this.singleCheckbox) {
        this.selectedCampaigns = [toggledCampaign]
        return
      }
      const selectedCampaignsDelta = this.selectedCampaigns.filter((campaign) => campaign._id !== toggledCampaign._id)

      if (selectedCampaignsDelta.length === this.selectedCampaigns.length) {
        selectedCampaignsDelta.push(toggledCampaign)
      }
      this.selectedCampaigns = selectedCampaignsDelta
    },

    link(item) {
      if (item.industry) {
        return `#/campanhas/gestao-ofertas/trade/resultados/${item._id}`
      } else {
        return `#/campanhas/gestao-ofertas/resultados/${item._id}`
      }
    },
    getOfferTypes(types) {
      const offerTypes = []
      types.forEach((type) => offerTypes.push(getProductFormatTypeLabel(type)))
      return offerTypes
    },

    getOfferTypesTooltip(types) {
      return this.getOfferTypes(types).join(', ')
    },
  },
}
</script>

<style lang="scss" scoped>
.offer-sales-container {
  max-height: 70vh !important;
}
</style>
